var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"section",class:[_vm.baseCss, _vm.rounded ? ['rounded', 'overflow-hidden'] : null, ("shadow-" + _vm.elevation), _vm.disabled ? ['disabled', 'pointer-events-none'] : null],attrs:{"role":"tree"}},[_c('ul',{class:['barebone-list'],attrs:{"role":"tree"}},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b373728","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/bcq-ui/components/collapsible/collapsible.vue
// module id = null
// module chunks = 